import axios from "../api/axios.js";
import Resizer from "react-image-file-resizer";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../api/firebase.js";
import { v4 as uuidv4 } from "uuid";

export function getFetchOptions(contentType, data, method) {
  const myHeaders = new Headers();
  const token = localStorage.getItem("token");

  const tokenExp = localStorage.getItem("tokenExp");

  // tokenExp sembra essere in secondi, mentre Date.now() è in millisecondi
  if (tokenExp && Date.now() > Number(tokenExp)) {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExp");
    localStorage.removeItem("role");
    localStorage.removeItem("userId");
    localStorage.removeItem("userSchoolId");
    localStorage.removeItem("userName");
    localStorage.removeItem("userImg");
    localStorage.removeItem("userSchoolId");

    window.location.href = "/login";
  }

  myHeaders.append("Content-Type", contentType);
  myHeaders.append("Authorization", "Bearer " + token);

  let body;

  if (contentType === "application/json") {
    body = JSON.stringify(data);
  } else if (contentType === "application/x-www-form-urlencoded") {
    const urlencoded = new URLSearchParams();
    for (const key in data) {
      urlencoded.append(key, data[key]);
    }
    body = urlencoded;
  }

  const requestOptions = {
    method: method,
    headers: myHeaders,
    body: body,
  };

  if (method === "GET") {
    delete requestOptions["body"];
  }

  return requestOptions;
}

export function checkUserRoleByToken(token) {
  const baseUrlSecurity = axios.defaults.baseURL + "/auth/getSecInfoByToken";
  const currentRole = localStorage.getItem("role");
  if (token) {
    axios.post(baseUrlSecurity + "?token=" + token).then((response) => {
      if (response.utente.idUserUtenti !== null) {
        if (currentRole === "insegnante") return true;
      }
      if (response.utente.idUserAdmin !== null) {
        if (currentRole === "admin") return true;
      }

      return false;
    });
  }
  return false;
}

export function convertIntoSelect2Options(data, valueKey, nameKey) {
  let options = [];
  data.forEach((element) => {
    let label;
    if (Array.isArray(nameKey)) {
      label = nameKey.map((key) => element[key]).join(" - ");
    } else {
      label = element[nameKey];
    }
    options.push({
      label: label,
      value: element[valueKey],
    });
  });

  return options;
}

export function customConvertIntoSelect2OptionsClasses(
  data,
  valueKey,
  classKey,
  sectionKey
) {
  let options = [];
  data.forEach((element) => {
    options.push({
      label: element[classKey] + " " + element[sectionKey],
      value: element[valueKey],
    });
  });

  return options;
}

export function resizeFile(file) {
  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      800, // larghezza massima
      800, // altezza massima
      "JPEG",
      80, // qualità (0-100)
      0, // rotazione
      (uri) => {
        resolve(uri);
      },
      "blob" // tipo di output
    );
  });
}

export async function uploadImage(file) {
  try {
    const filename = uuidv4();
    const compressedImage = await resizeFile(file);
    const imageRef = ref(storage, `images/${filename}.jpg`);
    const snapshot = await uploadBytes(imageRef, compressedImage);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error("Errore nel caricamento:", error);
  }
}
